// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#referrals {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

#referrals textarea {
  background-color: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(35, 50, 137, 0.5);
  border-radius: 2vh;
  font-size: 1rem;
  height: 50vh;
  margin: 0 7.5%;
  padding: 1rem;
  resize: none;
}

#referrals textarea::placeholder {
  color: rgba(35, 50, 137, 0.66);
}`, "",{"version":3,"sources":["webpack://./src/components/referrals/Referrals.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["#referrals {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n}\n\n#referrals textarea {\n  background-color: rgba(255, 255, 255, 0.86);\n  border: 1px solid rgba(35, 50, 137, 0.5);\n  border-radius: 2vh;\n  font-size: 1rem;\n  height: 50vh;\n  margin: 0 7.5%;\n  padding: 1rem;\n  resize: none;\n}\n\n#referrals textarea::placeholder {\n  color: rgba(35, 50, 137, 0.66);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
